import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { IconWrapper, Image, Optional } from '@honda-canada/design-system-react';
import Link from '../RoutableSitecoreLink';
import themeStyles, { NavLabel } from './BrandNavigation.styles';
var Item = themeStyles.apply(Link, 'Item');
var NavIconWrapper = themeStyles.apply(IconWrapper, 'NavIconWrapper');
var NavIcon = themeStyles.apply(Image, 'NavIcon');
var NavigationItem = function (_a) {
    var navImage = _a.navImage, navLink = _a.navLink;
    var showIcon = !isEmpty(navImage);
    var showItem = navLink === null || navLink === void 0 ? void 0 : navLink.text;
    return showIcon || showItem ? (React.createElement(Item, { showIcon: showIcon, "data-testid": "cy-brand-navigation-item", "aria-label": navLink === null || navLink === void 0 ? void 0 : navLink.text, field: {
            value: {
                linktype: navLink === null || navLink === void 0 ? void 0 : navLink.linktype,
                href: navLink === null || navLink === void 0 ? void 0 : navLink.href,
                target: navLink === null || navLink === void 0 ? void 0 : navLink.target,
            },
        } },
        React.createElement(Optional, { when: showIcon },
            React.createElement(NavIconWrapper, null,
                React.createElement(NavIcon, { "data-testid": "cy-brand-navigation-item-icon", src: navImage === null || navImage === void 0 ? void 0 : navImage.src, alt: navImage === null || navImage === void 0 ? void 0 : navImage.alt }))),
        React.createElement(Optional, { when: !showIcon },
            React.createElement(NavLabel, { as: "span", "data-testid": "cy-brand-navigation-item-label" }, navLink === null || navLink === void 0 ? void 0 : navLink.text)))) : null;
};
export default NavigationItem;
